import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BeerCcButtonProvider } from '../beer-cc-button/beer-cc-button';

/*
  Generated class for the BeerCcAnalysisProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable({
    providedIn: 'root'
})
export class BeerCcAnalysisProvider {

  private buttons: Array<any>;

  constructor(public http: HttpClient, private beerCcButtonProvider: BeerCcButtonProvider) {
    console.log('Hello BeerCcAnalysisProvider Provider');
    this.buttons = beerCcButtonProvider.getButtons();
  }
  public getButtons(): Array<any> {
    return this.buttons;
  }


}
